module.exports = __webpack_public_path__ + "static/media/telecommunications.6a8f213e.svg";